var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-4 flex p-2 sm:p-8"},[_c('vx-card',{attrs:{"title":"Términos y condiciones"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.terms)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }